import { Dispatch, SetStateAction } from "react";
import PermissionsOverview from "../components/PermissionsOverview";
import StepCard from "../components/StepCard";
import { GroupedPermissions } from "../type";
function AddRolePermissionStep({
  setGroupedPermissions,
  groupedPermissions,
}: {
  groupedPermissions: GroupedPermissions;
  setGroupedPermissions: Dispatch<
    SetStateAction<GroupedPermissions | undefined>
  >;
}) {
  return (
    <StepCard
      title="Setup accessibilities for this role"
      description="Choose the permissions this role has for each resource: view, edit, assign, or delete."
    >
      <div className="px-5 pb-4">
        {groupedPermissions && (
          <PermissionsOverview
            groupedPermissions={groupedPermissions}
            setGroupedPermissions={setGroupedPermissions}
            isEditable={true}
          />
        )}
      </div>
    </StepCard>
  );
}

export default AddRolePermissionStep;
